import { useContext, useState } from "react";
import {
  Button,
  Dialog,
  Dropdown,
  Checkbox
} from "iuvity-ui-components";
import { AppContext } from "../../context/index";
import { Upload } from "iuvity-ui-components/dist/upload";
import { Controller, useForm, useWatch } from "react-hook-form";
import { REVALIDATE_FORM_PROPS } from "../../constants";
import { useMasters } from "../../hooks/useMasters";
import { mastersFormatter } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useUploadAndDownload } from "../../hooks/useUploadAndDownload";
import { DialogProps } from "../../components/dialog/CustomDialog";

interface UploadNewFilesProps {
  setVisible: React.Dispatch<React.SetStateAction<boolean>>;
  reloadFn: Function;
  auxModalController: React.Dispatch<React.SetStateAction<DialogProps>>;
};

const formBlankValues = {
  file: "",
  servicePointTypeId: "",
  resetRecord: "NO"
};

export const UploadNewFiles: React.FC<UploadNewFilesProps> = ({ setVisible, reloadFn, auxModalController}) => {
  const navigate = useNavigate();
  const {
    t,
  } = useContext(AppContext);

  const {
    control,
    getValues,
    setValue,
    reset,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    delayError: 1200,
    reValidateMode: "onChange",
    defaultValues: formBlankValues,
  });

  const fileValues = useWatch({
    control: control,
    name: "file",
  });

  const servicePointTypeIdValues = useWatch({
    control: control,
    name: "servicePointTypeId",
  });

  const resetRecordValues = useWatch({
    control: control,
    name: "resetRecord",
  });

  const { uploadAndDownloadAction } = useUploadAndDownload("DATA");
  const { dataMaster } = useMasters("DATA");
  const dataServicePointType = mastersFormatter(dataMaster)
  const obj: any = {
    label: t("PointsOfAttention.allOptionLabel"),
    value: "all"
  }
  dataServicePointType?.unshift(obj)
  const formKeysOptions: any = {
    servicePointTypeId: dataServicePointType,
  };
  const [filePath, setFilePath] = useState<string>("");
  const [checked, setChecked] = useState(false);

  const onCancel = () => {
    setVisible(false);
  };

  const onHideModal = () => {
    setVisible(false);
    reset(formBlankValues);
  };

  const onCreateFile = async () => {
    const formValues = getValues();
    onHideModal();
    const data = {
      ...formValues,
      resetRecord: checked ? "YES" : "NO",
      servicePointTypeId: servicePointTypeIdValues !== 'all' ? servicePointTypeIdValues : null
    }
    const actionResult = await uploadAndDownloadAction("CREATE", data)
    if (actionResult === "SUCCESS") {
      reloadFn();
      navigate("/pointsofattention");
      window.scrollTo(0, 0);
    }
  };

  const handleModalProps = () => {
    auxModalController((prev) => ({
      ...prev,
      visible: true,
      title: t("PointsOfAttention.createFileModalTitle"),
      content: t("PointsOfAttention.createFileModalContent"),
      onConfirm: onCreateFile,
    }));
  };

  const invoiceUploadHandler = ({ files }: any) => {
    const [file] = files;
    setFilePath(file.name);
    setValue('file', file);
  };

  const invoiceRemoveHandler = () => {
    setFilePath("");
    setValue('file', "")
  };

  const renderFooter = () => {
    return (
      <div className="flex align-items-center justify-content-center">
        <Button
          label={t("PointsOfAttention.cancelBtnLabel")}
          onClick={onCancel}
          className="mr-4"
          variant="p-button-link"
        />
        <Button
          label={t("PointsOfAttention.uploadBtnLabel")}
          variant="p-button"
          onClick={handleModalProps}
          disabled={
            !(
              fileValues &&
              servicePointTypeIdValues &&
              isValid
            )
          }
        />
      </div>
    )
  };

  return (
    <Dialog
    id="dialogScroll1"
    className="dialog-form"
    header={t("PointsOfAttention.uploadNewFileModalTitle")}
    visible={true}
    onHide={onCancel}
    style={{
      width: `25rem`,
    }}
    footer={renderFooter()}
  >
    <>
      <div className="form sm">
        {Object.keys(formBlankValues)
                  .map((key) => (
                    <div style={{ paddingLeft: '1rem' }}>
                      <Controller
                        name={key as any}
                        control={control}
                        render={({ field }) => {
                          field.onChange = (e) => {
                            setValue(field.name, e.target.value, REVALIDATE_FORM_PROPS)
                          };
                          return key === 'file' ? 
                            <>
                                <label htmlFor={key} className="block lb mt-2 mb-2">
                                  {t(`PointsOfAttention.${key}Label`)}
                                </label>
                                <div className="mb-4">
                                  <Upload
                                    className={
                                      filePath !== ""
                                        ? "disabled"
                                        : ""
                                    }
                                    chooseLabel={
                                      filePath !== ""
                                        ?  filePath
                                        : t("PointsOfAttention.uploadFilenameLabel")
                                    }
                                    mode="basic"
                                    accept=".csv, .xlsx"
                                    customUpload={true}
                                    onClear={invoiceRemoveHandler}
                                    uploadHandler={invoiceUploadHandler}
                                    auto={true}
                                    disabled={filePath !== ""}
                                  />
                                </div>
                            </>
                          : key === 'servicePointTypeId' ?
                            <>
                              {/* @ts-ignore */} 
                              <div className='pointsofattention-fields'>
                                <Dropdown
                                  key={key}
                                  id={`dropdown-${key}`}
                                  className={`dropdown mb-4`}
                                  label={t(`PointsOfAttention.${key}Label`)}
                                  placeholder={t(`PointsOfAttention.${key}Placeholder`)}
                                  options={formKeysOptions[key]}
                                  showClear={false}
                                  style={{ zIndex: "6000 !important" }}
                                  {...field}
                                />
                              </div>
                            </>
                            :
                            <>
                              {/* @ts-ignore */} 
                              <div className='pointsofattention-fields'>
                                <Checkbox
                                  inputId={key}
                                  name={key}
                                  value={resetRecordValues}
                                  onChange={(e: any) => setChecked(e.checked)}
                                  checked={checked}
                                  required={false}
                                  label={t(`PointsOfAttention.${key}Label`)}
                                />
                              </div>
                            </>
                        }}
                      />
                    </div>
                ))}
      </div>
    </>
  </Dialog>
  );
};
